module.exports = __webpack_public_path__ + "static/media/tunnelin_vnc.dd590df5.jpg";